import { render, staticRenderFns } from "./Comercializacao.vue?vue&type=template&id=39f8964f&lang=pug"
import script from "./Comercializacao.vue?vue&type=script&lang=js"
export * from "./Comercializacao.vue?vue&type=script&lang=js"
import style0 from "./Comercializacao.vue?vue&type=style&index=0&id=39f8964f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports